// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import firebase from 'firebase'
import router from './router'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VCard,
  VTextField,
  VAlert,
  VExpansionPanel,
  VDataTable,
  VForm,
  VParallax,
  VCheckbox,
  VProgressCircular,
  VSnackbar,
  VSelect,
  VRadioGroup,
  VDatePicker,
  VDialog, 
  VTooltip,
  VSubheader,
  VDivider,
  VTabs,
  VBottomNav
} from 'vuetify'
import '../node_modules/vuetify/src/stylus/app.styl'
import { store } from './store'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VCard,
    VTextField,
    VAlert,
    VExpansionPanel,
    VDataTable,
    VForm,
    VParallax,
    VCheckbox,
    VProgressCircular,
    VSnackbar,
    VSelect,
    VRadioGroup,
    VDatePicker,
    VDialog,
    VTooltip,
    VSubheader,
    VDivider,
    VTabs,
    VBottomNav    
  },  
  theme: {
    primary: '#090809',
    secondary: '#F44E3F'
  }
})

Vue.config.productionTip = false
firebase.initializeApp({
  apiKey: 'AIzaSyC9g1My28DMvOgyUZoCgzLJo6FmSVD5O7c',
  authDomain: 'monthly-expenses-3ec05.firebaseapp.com',
  databaseURL: 'https://monthly-expenses-3ec05.firebaseio.com',
  projectId: 'monthly-expenses-3ec05',
  storageBucket: 'monthly-expenses-3ec05.appspot.com',
  messagingSenderId: '510475843033'
})

export const db = firebase.firestore()
firebase.firestore().settings({ timestampsInSnapshots: true})

/* eslint-disable no-new */
const unsubscribe = firebase.auth().onAuthStateChanged( (firebaseUser) => {
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    created() {
        if (firebaseUser) {
          store.dispatch('autoSignIn', firebaseUser)
        }
    }
  })
})




// WEBPACK FOOTER //
// ./src/main.js